export default __webpack_public_path__ + "static/media/people.1fb18331.png";